import { useState } from "react";
import copyToClipboard from "src/lib/copyToClipboard";

interface ShareClipboardProps {
	url: string;
}

const ShareClipboard = ({ url }: ShareClipboardProps) => {
	const [isCopied, setIsCopied] = useState(false);
	const onClick = () => {
		copyToClipboard(url);
		setIsCopied(true);
		setTimeout(() => {
			setIsCopied(false);
		}, 2000);
	};

	return (
		<div className="flex bg-gray py-3 px-4 max-w-full items-center overflow-hidden rounded-md relative">
			<div className="block flex-1 max-w-[60px]">
				<small className="whitespace-nowrap">{url}</small>
			</div>
			<div className="bg-gradient-to-l from-gray absolute top-0 bottom-0 right-0 w-24"></div>
			<div
				{...{ onClick }}
				className={`transition-all w-8 h-8 right-3 cursor-pointer text-white rounded-md absolute flex items-center justify-center ${
					isCopied ? "bg-green" : "bg-dark"
				}`}
			>
				<i
					className={`fas ${isCopied ? "fa-check" : "fa-clipboard"}`}
				></i>
			</div>
		</div>
	);
};

export default ShareClipboard;
